import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { HomepageSlider } from "../../website/partial-templates/slider/slider.stories";
import { renderPageTemplate, renderStandardPictureElement } from "../../utils";

export default {
    title: "Shared/Knowledge/Offers",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Teaser = () => {
    return html` <div
        class="ux-iws-teaser-universal ux-col-12 ux-col-md-4 ux-u-mb-s"
    >
        <ux-iws-link-wrapper>
            <div
                class="ux-u-shadow ux-u-h-100 ux-u-d-flex ux-u-flex-dir-column"
            >
                <div class="ux-iws-teaser-universal__media">
                    ${renderStandardPictureElement({
                        width: 1200,
                        height: 600,
                    })}
                </div>
                <div
                    class="ux-u-p-xs ux-u-d-flex ux-u-flex-dir-column ux-u-flex-jc-between ux-u-h-100"
                >
                    <div>
                        <span
                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                        >
                            Optimate: Zeit und Kosten sparen mit KI-optimierten
                            Bauteilen
                        </span>
                        <p class="ux-text-normal">
                            Mit Optimate Potentiale erkennen und Lösungen
                            finden. In 3 Schritten zu besseren Bauteilen:
                            Registrieren, passendes Paket wählen, Bauteil
                            hochladen und sofort das Einsparpotential und
                            Kostentreiber in Ihren Bauteilen erhalten.
                        </p>
                    </div>
                    <div class="ux-u-text-align--center">
                        <a class="ux-button">Mehr erfahren</a>
                    </div>
                </div>
            </div>
        </ux-iws-link-wrapper>
    </div>`;
};

const TeaserShop = () => {
    return html` <div
        class="ux-iws-teaser-universal ux-col-12 ux-col-md-6 ux-u-mb-s"
    >
        <ux-iws-link-wrapper>
            <div
                class="ux-u-shadow ux-u-h-100 ux-u-d-flex ux-u-flex-dir-column"
            >
                <div class="ux-iws-teaser-universal__media">
                    ${renderStandardPictureElement({
                        width: 1200,
                        height: 600,
                    })}
                </div>
                <div
                    class="ux-u-p-xs ux-u-d-flex ux-u-flex-dir-column ux-u-flex-jc-between ux-u-h-100"
                >
                    <div>
                        <span
                            class="ux-text-title ux-text-title--bold ux-text-title--green-square"
                        >
                            Servicevereinbarungen
                        </span>
                        <p class="ux-text-normal">
                            Erhöhen Sie ganz entspannt Ihre Anlagenverfügbarkeit
                            – und verbessern Sie zudem Ihre Produktionsqualität
                            bei planbaren Kosten.
                        </p>
                    </div>
                    <div class="ux-u-text-align--center">
                        <a class="ux-button">Mehr erfahren</a>
                    </div>
                </div>
            </div>
        </ux-iws-link-wrapper>
    </div>`;
};

const Template = () => {
    return html`
        <div class="ux-t-container-full ux-u-mb-fluid-m">
            <div class="ux-u-mb-l">${HomepageSlider()}</div>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        Trumpf E-Shop
                    </h2>
                </div>
            </div>
            <div class="ux-row ux-u-background-grey ux-u-my-l">
                <div class="ux-col-10 ux-u-offset-1 ux-u-mt-nl ux-u-mb-l">
                    <ux-iws-media-bar>
                        <div slot="media">
                            ${renderStandardPictureElement({
                                width: 1200,
                                height: 600,
                            })}
                        </div>
                        <div slot="content" class="ux-u-p-s ux-u-p-lg-m">
                            <div class="ux-text-title ux-text-title--light">
                                Schnell und einfach Original Teile bestellen
                            </div>
                            <p class="ux-text-normal ux-u-mb-xs">
                                Der TRUMPF E-Shop unterstützt Sie mit vielen
                                hilfreichen Filtern und Funktionen bei der
                                Suche, Auswahl und Bestellung Ihrer Original
                                Teile. Dabei ist der E-Shop individuell auf
                                Ihren Maschinenpark abgestimmt. Kontinuierlich
                                wird er um weitere intelligente Funktionen
                                erweitert, sodass Sie Ihre Original Teile bequem
                                und schnell bestellen können.
                            </p>
                            <ux-button type="button">Mehr erfahren</ux-button>
                        </div>
                    </ux-iws-media-bar>
                </div>
            </div>
        </div>
        <div class="ux-t-container">
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        TruServices – Your Partner in Performance
                    </h2>
                </div>
            </div>
            <div class="ux-row">${[...Array(4)].map(() => TeaserShop())}</div>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        Ihre lokalen Angebote auf einen Blick
                    </h2>
                </div>
            </div>
            <div class="ux-row">${Teaser()}</div>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        Das könnte Sie auch interessieren
                    </h2>
                </div>
            </div>
            <div class="ux-row">${[...Array(3)].map(() => Teaser())}</div>
        </div>
    `;
};

export const Default = () => renderPageTemplate(() => Template());
